<template>
  <div class="svoi-input-wrapper">
    <label class="svoi-input" :class="classes" @click="onActivate">
      <span class="label">
        {{ label }}
        <span v-if="required" class="-required">*</span>
      </span>
      <span class="input-wrapper">
        <span class="input-before">
          <slot name="input-before"></slot>
        </span>
        <input
          ref="inputRef"
          v-model="computedValue"
          v-mask="mask"
          :type="computedType"
          class="input"
          :readonly="readonly"
          :disabled="disabled"
          :maxlength="maxLength"
          :placeholder="placeholder"
          :tabindex="tabindex"
          :qa-locator="computedQaLocator"
          @focus="onActivate"
          @blur="onBlur"
          @change="onChange"
          @keyup="$emit('keyup', $event)"
        />
      </span>

      <slot name="input-after">
        <SvoiIcon
          v-if="type === 'password'"
          class="icon"
          :icon="iconEye"
          size="m"
          :qa-locator="computedQaLocator ? `${computedQaLocator}-right-icon` : undefined"
          @click="onClickEye"
        />
        <SvoiIcon
          v-else-if="icon"
          class="icon"
          :icon="icon"
          size="m"
          :qa-locator="computedQaLocator ? `${computedQaLocator}-right-icon` : undefined"
          @click="onClickIcon"
        />
      </slot>
    </label>
    <SvoiHint v-if="hint || error" class="hint" theme="chilli">{{ hint || error }}</SvoiHint>
  </div>
</template>

<script lang="ts">
import { defineComponent, isVue2 } from 'vue-demi'
import type { DirectiveOptions, PropType } from 'vue-demi'
import { SvoiHint } from '@svoi-ui/components/hint'
import { SvoiIcon } from '@svoi-ui/components/icon'
import { mask } from '@svoi-ui/shared/directive'
import type { InputMask } from '@svoi-ui/shared/directive'
import { BaseInputComponent } from './BaseInput'

const directives = {
  mask: isVue2
    ? (mask as DirectiveOptions)
    : ({
        beforeMount: mask.bind,
        updated: mask.componentUpdated,
        unmounted: mask.unbind
      } as DirectiveOptions)
}

export default defineComponent({
  name: 'SvoiMaskedInput',
  components: { SvoiHint, SvoiIcon },
  directives,
  extends: BaseInputComponent,
  props: {
    ...BaseInputComponent.props,
    mask: {
      type: [String, Function, Array] as PropType<InputMask>,
      default: ''
    }
  },
  setup(props, ctx) {
    // @ts-expect-error
    const bindComponent = BaseInputComponent?.setup ? BaseInputComponent.setup(props, ctx) : {}

    return { ...bindComponent }
  }
})
</script>

<style lang="scss" scoped>
@use '@svoi-ui/assets/scss/components/input.scss';
</style>
